import { useTheme } from 'styled-components';
import { useMediaQuery } from 'styled-breakpoints/use-media-query';
import { Navigation, MobileNavigation } from 'components/Navigation';
import { LoginLink, SignupLink } from 'components/Links';

import { HeaderContainer } from './HeaderContainer.styled';
import { Nav } from './Nav.styled';
import { SharesightLogo } from './Logo.styled';
import { CTAVisibility } from './CTAVisibility.styled';

import type { FC } from 'react';

export interface HeaderProps {}

export const Header: FC<HeaderProps> = () => {
  const { breakpoints } = useTheme();

  const isTablet = !!useMediaQuery(breakpoints.down('lg'));

  return (
    <HeaderContainer>
      <Nav role="navigation" aria-label="Sharesight">
        {/* Right aligning the logo on desktop devices */}
        {!isTablet && <SharesightLogo />}
        <Navigation />
        <MobileNavigation />
        {/* Centering the logo on tablet and mobile devices */}
        {isTablet && <SharesightLogo />}

        <CTAVisibility>
          <LoginLink asButton />
        </CTAVisibility>
        <SignupLink asButton>Sign up</SignupLink>
      </Nav>
    </HeaderContainer>
  );
};
